import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import { ProductAttribute, ProductDetailInfo } from "../../model_def"
import View from "../Base/View"
import Block from "../Base/Block";
import './index.scss'
import Image from "../Base/Image";
import Price from "../Price";
import ScrollView from "../Base/ScrollView";
import Text from "../Base/Text";
import { Input, Modal } from "antd";
import './dialog.scss'
import httpUtil from "../../utils/httpUtil";
import { toast } from "../../utils/toast";
import util from "../../utils/util";
import userUtils from "../../manager/userUtils";
import cartMaganer from "../../manager/cart";
import rm from "../../utils/rm";

export interface SelectSpecific {
  AttributeId: number,
  AttributeValue: {
    AttributeValueId: number,
    AttributeText: string,
    AttributeDate: string,
    CustomerEnteredQuantity: number,
  }[]
}

export interface SpecificPannelProp {
  productInfo: ProductDetailInfo,
  timeCountdown: boolean,
  onSpecificChange: (info: any) => void,
  onAddCartSuccess: (info: any) => void;
}


export interface SpecificPannelRef {
  /**
   * 打开商品规格选择面板
   * @param type  初始关闭；0：关闭；1：选规格；2：选规格添加购物车；3：选规格下单
   * @returns 
   */
  openFor: (type: number) => void
}

const SpecificPannel = forwardRef((prop: SpecificPannelProp, _ref) => {

  const { productInfo, timeCountdown } = prop;
  const [openType, setOpenType] = useState<number>(-1)
  const [currentSelectedSpecific, setCurrentSelectedSpecifics] = useState<(SelectSpecific | undefined)[]>([])
  const [userSelectSpecificDes, setUserSelectSpecificDes] = useState<boolean | string>(false);
  const [userSelectCount, setUserSelectCount] = useState<number>(1)
  const [userSelectAllSpecific, setUserSelectAllSpecific] = useState<boolean>(false);
  const [Stock, setStock] = useState<number>(1)
  const [pictureUrl, setPictureUrl] = useState<string | false>();
  const [checking, setChecking] = useState<boolean>(false);
  const [checkedPrice, setCheckedPrice] = useState<string>('¥0.00');
  const [OldPrice, setOldPrice] = useState<number>(0)
  const [OldPriceStr, setOldPriceStr] = useState<string>('');
  // const [inputCountText, setInputCountText] = useState<string>('1');
  const [isAddingCart, setAddingCart] = useState<boolean>(false);
  const [noneSelectAttributesNameStr, setNoneSelectAttributesNameStr] = useState<string>('');
  const isCaculating = useRef<boolean>(false)

  useEffect(() => {
    if (openType === 0) {
      setTimeout(function () {
        setOpenType(-1)
      }, 250)
    }
  }, [openType])


  useImperativeHandle(_ref, () => ({
    /**
     * //-1：初始关闭；0：关闭；1：选规格；2：选规格添加购物车；3：选规格下单
     * @param type 
     */
    openFor: (type: number) => {
      setOpenType(type)
    }
  }))



  useEffect(() => {
    const newValue = productInfo;
    if (
      newValue.ProductAttributes &&
      typeof newValue.ProductAttributes !== typeof undefined
    ) {
      // 商品信息有更新时:
      // 1、需对currentSelectedSpecific重排序，与productInfo顺序一致
      // 2、过滤非单选项，目前不支持非单选项
      var attrList: ProductAttribute[] = []
      var attrIdList: number[] = []
      newValue.ProductAttributes.forEach(function (attribute) {
        if (attribute.AttributeControlType === 2) {
          attrList.push(attribute)
          attrIdList.push(attribute.Id)
        } else {
          console.log('商品包含非单选属性！！！！！！！！！！！！！！')
        }
      })
      newValue.ProductAttributes = attrList
      setCurrentSelectedSpecifics((preValue: (SelectSpecific | undefined)[]) => {
        var newSpecificOrders: (SelectSpecific | undefined)[] = []
        preValue.forEach(function (item) {
          if (item) {
            var attrId = item.AttributeId
            var attrIndex = attrIdList.indexOf(attrId)
            if (attrIndex !== -1) {
              newSpecificOrders[attrIndex] = item
            }
          }
        })
        return newSpecificOrders
      })
    }

  }, [productInfo])

  /**
   * 过滤规格
   * @returns 
   */
  const _filterSelectedSpecifics = function () {
    return currentSelectedSpecific.filter((item) => {
      return typeof item != typeof undefined
    })
  }
  /**
   * 验证属性值组合是否可用
   */
  const _checkAttributeValidate = function (specific: any, callback: (success: boolean, res: any, tips: string) => void) {
    var postData = {
      ProductId: specific.ProductId,
      ProductAttributes: specific.ProductAttributes.filter((item: any) => {
        return typeof item !== typeof undefined
      })
    }
    httpUtil.link(
      'productdetailsattributechange',
      'POST',
      JSON.stringify(postData),
      true,
      function (success: boolean, res: any, tips: string) {
        if (callback !== null) callback(success, res, tips)
      }
    )
  }
  const _onCloseClick = () => {
    var oldState = openType
    var newState = oldState == 0 || oldState == -1 ? 1 : 0
    setOpenType(newState)
  }

  const _consumeTouchmove = () => {

  }

  /**
    * 生成描述、最低/最高价格
    */
  const _generateSpecificDes = (neecCheck: boolean = true) => {
    if (typeof productInfo.Id === typeof undefined) {
      return
    }
    isCaculating.current = true;
    var specificDes: string | boolean = false
    var selectAll = true
    var allAttrs = productInfo.ProductAttributes
    var noSelectTips = ''
    for (var index = 0; index < allAttrs.length; index++) {
      if (
        index < currentSelectedSpecific.length &&
        typeof currentSelectedSpecific[index] !== typeof undefined
      ) {
        // 已选中规格
        var attrValueIdIndex = allAttrs[index].Values.findIndex(
          (attrItem) => {
            const compareTo = currentSelectedSpecific[index];
            return (
              compareTo &&
              attrItem.Id ==
              compareTo.AttributeValue[0]
                .AttributeValueId
            )
          }
        )
        var valueName = allAttrs[index].Values[attrValueIdIndex].Name
        specificDes = !specificDes
          ? '已选择' + valueName
          : specificDes + ',' + valueName
      } else {
        // 未选中规格
        // 判断是不是必须选择的属性
        if (allAttrs[index].IsRequired) {
          // 此为必选属性
          selectAll = false
          noSelectTips += ' ' + allAttrs[index].Name
        }
      }
    }
    setUserSelectSpecificDes(specificDes)
    setUserSelectAllSpecific(selectAll)
    setPictureUrl(selectAll ? pictureUrl : false)
    setNoneSelectAttributesNameStr(noSelectTips)
    var result = {
      // 直接对应购物差字段
      specific: {
        ProductId: productInfo.Id,
        Quantity: userSelectCount,
        // ShoppingCartTypeId: 1,
        ProductAttributes: _filterSelectedSpecifics(),
      },
      specificDes: specificDes
        ? specificDes
        : false,
      isSelectedAll: userSelectAllSpecific,
    }

    // 这里对选择的型号进行服务端验证 selectAll
    if (selectAll && neecCheck) {
      setChecking(true);
      isCaculating.current = true;
      _checkAttributeValidate(
        result.specific,
        function (success, res, tips) {
          if (success) {
            var info = res.data.Content
            var selectCount = userSelectCount
            if (productInfo.ManageInventoryMethod == 0) {
              // 不跟踪库存，始终有货
              if (selectCount <= 0) {
                selectCount = 1
              }
            } else if (info.Stock <= 0) {
              // 跟踪库存，但缺货
              selectCount = 0
            } else {
              // 跟踪库存，有货
              if (selectCount > info.Stock) {
                selectCount = info.Stock
              }
              if (selectCount <= 0) {
                selectCount = 1
              }
            }
            setStock(info.Stock)
            setOldPrice(info.OldPrice)
            setCheckedPrice(info.PriceStr)
            setPictureUrl(info.PictureUrl)
            setUserSelectCount(selectCount)
            setChecking(false)
            prop.onSpecificChange(result)
          } else {
            setChecking(false)
            toast.error(tips)
          }
          isCaculating.current = false;
        }
      )
    } else {
      isCaculating.current = false;
      prop.onSpecificChange(result)
    }
  }


  useEffect(() => {
    _generateSpecificDes(true)
  }, [productInfo, currentSelectedSpecific, userSelectCount, userSelectAllSpecific])


  /**
   * 型号变更。目前只考虑单选
   */
  const _onSpecificSelected = (data: any) => {
    var that = this
    var attrId = data.attrid;

    var attrIdIndex = parseInt(
      data.attridindex
    )
    var attrValueId = parseInt(
      data.attrvalueid
    )
    var attrValueIdIndex = parseInt(
      data.attrvalueidindex
    )
    var newState = currentSelectedSpecific.slice(0)
    if (
      newState.length > attrIdIndex &&
      typeof newState[attrIdIndex] !== typeof undefined
    ) {
      const target = newState[attrIdIndex];
      if (target) {
        if (
          target.AttributeValue[0].AttributeValueId == attrValueId
        ) {
          newState[attrIdIndex] = undefined
        } else {
          target.AttributeValue[0].AttributeValueId = attrValueId
        }
      }

    } else {
      newState[attrIdIndex] = {
        AttributeId: attrId,
        AttributeValue: [
          {
            AttributeValueId: attrValueId,
            AttributeText: 'string',
            AttributeDate: '2018-08-14T08:38:47.864Z',
            CustomerEnteredQuantity: 0,
          },
        ],
      }
    }
    setCurrentSelectedSpecifics(newState)
  }


  const _addCartAndCheckout = function (needCheckout: boolean) {
    if (timeCountdown) {
      toast.info('即将开始')
      return
    }

    if (userSelectCount <= 0) {
      toast.info('购买数量需大于0')
      return
    }
    if (userSelectAllSpecific) {
      // this.triggerEvent('addcartclickevent', {})
      if (checking) {
        return
      }
      userUtils.doTaskInLoginState(function (state) {
        if (state.success) {
          if (!isAddingCart) {
            setAddingCart(true);
            var specificInfo = {
              IsBuyNow: needCheckout,
              ProductId: productInfo.Id,
              Quantity: userSelectCount,
              // ShoppingCartTypeId: 1,
              ProductAttributes: _filterSelectedSpecifics(),
            }
            if (needCheckout) {
              toast.loading("准备结算", 0, "checkingOut")
            }
            cartMaganer.addCart(
              specificInfo,
              function (success: boolean, res: any, tips: string) {
                toast.destory("checkingOut")
                if (needCheckout && success) {
                  // 立即购买 —— 添加购物车并结算
                  _onCloseClick()

                  var ids = [res]
                  util.navigateTo(
                    '/order/checkout?isrmmp=1&hidemenu=1&ids=' +
                    encodeURIComponent(ids.join(","))
                  )
                } else {
                  // 添加购物车
                  if (success) {
                    // 通知页面执行添加动画
                    _onCloseClick()
                    prop.onAddCartSuccess({
                      pictureUrl: pictureUrl
                        ? pictureUrl
                        : productInfo.DefaultPictureUrl,
                    })
                  } else {
                    toast[success ? 'success' : 'error'](tips)
                  }
                }
                setAddingCart(false)
              }
            )
          } else {
            toast.info('操作执行中，请稍等')
          }
        } else {
          if (rm.isSupportMallClient()) {
            toast.info('请登录后操作')
          } else {
            Modal.confirm({
              title: "请在IT之家App内操作", okText: "下载IT之家App", cancelText: "取消", onOk: () => {
                rm.navigateTo({
                  url: "http://m.ithome.com/ithome/download/"
                })
              }
            })
          }

        }
      })
    } else {
      var title = '请选择商品规格'
      if (!util.isEmpty(noneSelectAttributesNameStr)) {
        title = '请选择' + noneSelectAttributesNameStr
      }
      toast.info(title)
    }
  }


  return <View className="specific-panel">
    <View
      className={
        'pannel-msk-state-' +
        (openType == -1 ? 'init' : openType != 0 ? 'open' : 'close') +
        ''
      }
      onClick={_onCloseClick}
      onTouchMove={_consumeTouchmove}
    ></View>
    <View
      className={
        'padding-safe-area  pannel-state-' +
        (openType == -1 ? 'init' : openType != 0 ? 'open' : 'close') +
        ' pannel-inner '
      }
      onTouchMove={_consumeTouchmove}
    >
      <Image
        className="pannel-thumb"
        src={pictureUrl ? pictureUrl : productInfo?.DefaultPictureUrl}
      ></Image>
      <View className="specific-info">
        <View className="specific-price">
          <Price
            value={
              userSelectAllSpecific
                ? checkedPrice
                : productInfo?.ProductPrice?.Price
            }
            size={30}
          ></Price>
          <Price
            value={OldPrice > 0 ? OldPriceStr : ''}
            size={24}
            color="#bbbbbb"
            del={true}
            style={{
              marginLeft: '0.5rem',
            }}
          ></Price>
        </View>
        {/* wx:if="{{userSelectAllSpecific}}" {{minPrice !=m axPrice ? ('¥' + minPrice + ' ~ ') : ''}}{{'¥' + maxPrice}}  */}
        <View className="specific-stock">
          {productInfo?.ManageInventoryMethod == 0 ? (
            <Block>有货</Block>
          ) : userSelectAllSpecific ? (
            <Block>{Stock > 0 ? '库存' + Stock + '件' : '缺货'}</Block>
          ) : (
            <Block>
              {productInfo?.TotalStockQuantity > 0
                ? '库存' + productInfo?.TotalStockQuantity + '件'
                : '缺货'}
            </Block>
          )}
        </View>
        {productInfo?.ProductAttributes?.length > 0 && (
          <View className="specific-result">
            {userSelectSpecificDes
              ? userSelectSpecificDes +
              (userSelectCount > 0 ? ' 共' + userSelectCount + '件' : '')
              : '请选择规格'}
          </View>
        )}
      </View>
      {productInfo?.Id > 0 && (
        <ScrollView
          scrollY={true}
          enableBackToTop={true}
          scrollWithAnimation={true}
          className="specific-list scrollbar-hide"
        >
          {productInfo?.ProductAttributes?.map(
            (specificItem, specificIndex) => {
              return (
                <View className="specific-list-item">
                  <View className="specific-name">{specificItem.Name}</View>
                  <View className="specific-value-list">
                    {specificItem.Values.map((item, index) => {
                      return (
                        <Text
                          className={
                            'specific-value' +
                            (isActivedValue(
                              currentSelectedSpecific,
                              specificIndex,
                              item.Id
                            )
                              ? ' specific-value-active'
                              : '')
                          }
                          onClick={() => {
                            _onSpecificSelected({
                              attrid: specificItem.Id,
                              attridindex: specificIndex,
                              attrvalueid: item.Id,
                              attrvalueidindex: index,
                            })
                          }}
                        >
                          {item.Name}
                        </Text>
                      )
                    })}
                  </View>
                </View>
              )
            }
          )}
          <View className="specific-count">
            <View className="specific-name specific-name-count">
              购买数量
            </View>
            <View className="product-count">
              <Image
                className="product-count-tunel product-count-del"
                src={require('../../images/count-del' +
                  (userSelectCount > 1 ? '' : '-disable') +
                  '.png')

                }
                onClick={() => {
                  if (isCaculating.current) {
                    return
                  }
                  if (userSelectCount > 1) {
                    const tocount = userSelectCount - 1;
                    setUserSelectCount(tocount)
                  }
                }}
              ></Image>
              <Text
                className="product-select-count"
              // type="number"
              // autoFocus
              // value={`${userSelectCount}`}
              // onChange={(e) => {
              //   if (
              //     !util.isEmpty(e.target.value) &&
              //     util.isNumber(e.target.value)
              //   ) {
              //     setUserSelectCount(parseInt(e.target.value))
              //   } else {
              //     setUserSelectCount(userSelectCount)
              //   }
              // }}
              >{userSelectCount}</Text>
              <Image
                className="product-count-tunel product-count-add"
                src={require('../../images/count-add.png')}
                onClick={() => {
                  if (isCaculating.current) {
                    return
                  }
                  const toCount = userSelectCount + 1;
                  setUserSelectCount(toCount)
                }}
              ></Image>
            </View>
            {/*  <view>提示</view>  */}
          </View>
        </ScrollView>
      )}
      <View className="specific-pannel-btn padding-safe-area ">
        {productInfo?.AddToCart?.DisableBuyButton ? (
          <View className="specific-out-of-stock">商品已下架</View>
        ) : timeCountdown ? (
          <View className="pre-order-btn" onClick={() => {
            toast.info("即将开始")
          }}>
            即将开始
          </View>
        ) : productInfo?.ManageInventoryMethod != 0 &&
          userSelectAllSpecific &&
          !checking &&
          Stock === 0 ? (
          <View className="specific-out-of-stock">缺货</View>
        ) : openType == 2 || openType == 3 ? (
          <View className="specific-confirm" onClick={() => {
            if (!util.allowClick()) {
              return
            }
            if (openType === 2) {
              //加入购物车
              _addCartAndCheckout(false)
            } else {
              // this._buyClick()
              _addCartAndCheckout(true)
            }
          }}>
            {checking ? (
              <View className="spinner">
                <View className="double-bounce1"></View>
                <View className="double-bounce2"></View>
              </View>
            ) : (
              <Text>{openType === 2 ? "加入购物车" : "立即购买"}</Text>
            )}
          </View>
        ) : (
          openType == 1 && (
            <Block>
              <View
                className="specific-addcart"
                onClick={() => {
                  if (!util.allowClick()) {
                    return
                  }
                  _addCartAndCheckout(false)
                }}
              >
                加入购物车
              </View>
              <View
                className="specific-buy"
                onClick={() => {
                  if (!util.allowClick()) {
                    return
                  }
                  _addCartAndCheckout(true)
                }}
              >
                立即购买
              </View>
            </Block>
          )
        )}
      </View>
    </View>
  </View>
})

export default SpecificPannel;

function isActivedValue(currentSelectedSpecific: (SelectSpecific | undefined)[], attrIdIndex: number, attrValueId: number) {
  if (
    currentSelectedSpecific.length > attrIdIndex &&
    typeof currentSelectedSpecific[attrIdIndex] !== typeof undefined &&
    currentSelectedSpecific[attrIdIndex] != null
  ) {
    const target = currentSelectedSpecific[attrIdIndex];
    return (target &&
      target.AttributeValue[0].AttributeValueId ==
      attrValueId
    )
  }
  return false
}